export function Brand({ compact = false }: { compact?: boolean }) {
  return <a className={`brand${compact ? ' brand-compact' : ''}`} href="/" aria-label="The Owner's Desk home">
    <span className="brand-symbol" aria-hidden="true"><i /><i /><i /></span>
    <span><strong>The Owner’s Desk</strong>{!compact && <small>Home project intelligence</small>}</span>
  </a>
}
